import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import useStyles from './styles';

const textPosition = {
  left: 'left',
  right: 'right',
  center: 'center',
};

const DividerWithTitle = ({
  title,
  lineHeight,
  color,
  position = textPosition.left,
  className,
}) => {
  const classes = useStyles({ lineHeight, color });
  return (
    <div className={cx(classes.dividerWithTitle, className)}>
      {position !== textPosition.left && <div className={classes.divider} />}
      <div style={{ display: 'flex', gap: '5px' }}>
        <div>{title}</div>
      </div>
      {position !== textPosition.right && <div className={classes.divider} />}
    </div>
  );
};

DividerWithTitle.propTypes = {
  title: PropTypes.string.isRequired,
  lineHeight: PropTypes.number,
  color: PropTypes.string,
  position: PropTypes.oneOf([
    textPosition.left,
    textPosition.right,
    textPosition.center,
  ]),
  className: PropTypes.string,
};

export default DividerWithTitle;
